import { render, staticRenderFns } from "./app-ios.vue?vue&type=template&id=34f72ff2&scoped=true"
import script from "./app-ios.vue?vue&type=script&lang=js"
export * from "./app-ios.vue?vue&type=script&lang=js"
import style0 from "./app-ios.vue?vue&type=style&index=0&id=34f72ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f72ff2",
  null
  
)

export default component.exports